// extracted by mini-css-extract-plugin
export var emailBlockLink = "_lk-0";